<template>
  <div id="footer" class="container-fluid">
    <div class="footer-main">
      <span class="contactInfo">
        <ul>
          <li style="font-size: 40px"><i class="el-icon-phone-outline" style="margin-right: 15px;font-size: 45px;color: RGB(80,138,245)"/> 028-6131-1003</li>
          <li><p style="font-size: 14px;color: #bfbfbf;line-height: 28px;margin-top: 25px;">地址：成都市青羊区一环路西二段2号1栋16楼1602号</p></li>
        </ul>
      </span>
      <span class="companyInfo">
        <ul>
          <li style="font-size: 30px;color: #656769;line-height: 60px;margin-bottom: 15px">关于我们</li>
          <li><p style="font-size: 14px;color: #bfbfbf;line-height: 28px">四川国盈非融资性担保有限公司是一家以工程担保为核心产业的专业担保机构，公司注册资本5000万元人民币。公司主营业务包括：投标担保、预付款担保、工程履约担保、尾付款如约偿付担保，业务范围覆盖市政、房建、公路、水利、监理、园林、机电、消防、智能化、钢结构等多个工程建设板块。</p></li>
        </ul>
      </span>
<!--      <ul>-->
<!--        <li class="title"><i class="el-icon-phone-outline" size="6"/>028-6131 1003</li>-->
<!--&lt;!&ndash;        <li>邮箱：xxxx@xx.com</li>&ndash;&gt;-->
<!--        <li>地址：成都市青羊区一环路西二段2号1栋16楼1602号</li>-->
<!--      </ul>-->
<!--      <ul>-->
<!--        <li class="title">服务特色</li>-->
<!--        <li class="sys" >四川蜀汇非融资性担保有限公司于2014年9月成立，并与同年12月获得四川省建设厅专业工程担保机构备案。是从事工程担保及相关风险管理的专业机构。业务范围：工程类非融资性担保、工程银行保函、工程保险等。 业务品种：工程投标担保、工程履约担保、工程民工工资支付担保、质量保证金担保、建工险、诉讼保全等</li>-->
<!--      </ul>-->

<!--      <ul>-->
<!--        <li>-->
<!--          <img class="footer-code" src="@/assets/img/code.jpeg" alt="二维码">-->
<!--        </li>-->
<!--        <li style="text-align: center;">-->
<!--          扫一扫关注公众号-->
<!--        </li>-->
<!--      </ul>-->
    </div>
    <p class="copy" style="color: #444f55;border-top: 1px solid #444f55;padding-top: 15px">
      Copyright &copy; {{ year }} GuoYing Inc.
      <a target="_blank" href="https://beian.miit.gov.cn" style="color: #383838">蜀ICP备2023002921号</a>
    </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      imgs: require("@/assets/img/logo.png"),
      year:new Date().getFullYear()
    };
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: rgba(255, 255, 255, 0.65);
  background: #000000;
  overflow: hidden;
}
.footer-main {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: flex-start;
  padding-top: 25px;
  font-size: 12px;
}
.footer-logo {
  width: 135px;
  height: 35px;
}

.footer-code {
  width: 150px;
  height: 150px;
}

.title {
  font-size: 25px;
  margin-bottom: 20px;
  color: rgba(255, 255, 255, 1);
}
.copy {
  font-size: 14px;
  margin: 30px 0 10px;
  text-align: center;
}
.contactInfo{
  width: 35%;
}
.companyInfo{
  width: 40%;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
    text-align: center;
  }
  .contactInfo{
    width: 100% !important;
  }
  .companyInfo{
    display: none;
  }
}
.sys {
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue